export enum AttributeType{
    TempEditorElement = -100,

    Integer = 1,
    String = 2,
    Decimal = 3,
    Date = 4,
    Time = 5,
    DateTime = 6,
    Checkbox = 7,
    Select = 8,
    MultiSelect = 9
}